import React from 'react';
import Modal from '../../components/Modals/Modal';
import ReactSelect from '../../components/Inputs/ReactSelect';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';

function AddCollaboratorModal({
  showAddCollaborator,
  setShowAddCollaborator,
  addTreatmentCollaborator,
  treatmentId,
  allClinicPartners,
  treatmentCollaborators
}) {

  const [ newCollaborator, _setNewCollaborator] = React.useState({
    partnerId: null,
    partnerName: null,
    email: null
  });
  
  const clinicPartnersNotCollaborators = allClinicPartners.filter(p => !treatmentCollaborators.some(c => c.user_id._id === p.user_id._id))
  
  const selectPartnerOptions = clinicPartnersNotCollaborators.map(partner => ({
    label: partner.user_id.first_name + ' ' + partner.user_id.last_name, 
    value: partner.user_id._id, 
    email: partner.user_id.email
  }));

  const handleCancelAddCollaborator = () => {
    setShowAddCollaborator(false);
  }

  const handleAddCollaborator = () => {
    addTreatmentCollaborator({ collaboratorId: newCollaborator.partnerId, treatmentId });
    _setNewCollaborator({
      partnerId: null,
      partnerName: null,
      email: null
    });
    setShowAddCollaborator(false);
  }

  return (
    <Modal title={'Add Collaborator'} show={showAddCollaborator} hide={handleCancelAddCollaborator}>
      <div className='flex flex-col'>
        <div className='grid grid-cols-1 gap-y-1 my-8'>
          <span className='mb-2'>Please select a collaborator:</span>
          <ReactSelect 
            options={selectPartnerOptions} 
            value={newCollaborator.partnerName}
            onChange={(e) => _setNewCollaborator({partnerName: e.label, partnerId: e.value, email: e.email})}
          />
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={handleCancelAddCollaborator} text='Cancel'/>
          <PrimaryButton disabled={newCollaborator.partnerName ? false : true } text={'Save'} onClick={handleAddCollaborator} />
        </div>
      </div>
    </Modal>
  )
}

export default AddCollaboratorModal